import TypeGuard from './TypeGuard'

export default TypeGuard
